import { Record } from 'immutable';

const HFUsageRecord = Record({
  studentId: undefined,
  gainedDiamonds: undefined,
  totalDiamonds: undefined,
  onlineUsages: undefined,
});

class HFUsage extends HFUsageRecord { }

export default HFUsage;



// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/model/model.js